import { useEffect } from "react";
import * as Keyboard from "@tootools/keyboard";

const useKeyboardShortcuts = (context, shortcuts) => {
  useEffect(() => {
    Keyboard.addShortcuts(context, shortcuts);
    return () => {
      Keyboard.removeShortcuts(context, shortcuts);
    };
  });
};

export default useKeyboardShortcuts;
